import { withInstall } from '@ll-plus/utils'

import OperateIcon from './src/operate-icon.vue'

export const LlOperateIcon = withInstall(OperateIcon)
export default LlOperateIcon
export * from './src/operate-icon'

declare module 'vue' {
  export interface GlobalComponents {
    LlOperateIcon: typeof OperateIcon
  }
}
